import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, catchError, first } from 'rxjs/operators';
import { AppSettings } from '../app-settings';
import { Observable, of, throwError } from 'rxjs';
import { CommonService } from './common.service';
import { formatDate } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class CiudadesService {
  constructor(
    private http: HttpClient,
    private common: CommonService,
  ) {}

  getCiudades() {
    const url = `${AppSettings.API_URI_V2}/cities`;
    return this.common.getData(url);
  }

  getCitiesWithEvents() {
    const url = `${AppSettings.API_URI_V2}/events/cities`;
    return this.common.getData(url);
  }

  getCiudadbyId(id: number) {
    const url = `${AppSettings.API_URI_V2}/cities/${id}`;
    return this.common.getData(url);
  }

  getCountries() {
    const url = `${AppSettings.API_URI_V2}/countries`;
    return this.common.getData(url);
  }

  getStates() {
    const url = `${AppSettings.API_URI_V2}/states`;
    return this.common.getData(url);
  }

  getAllCitieByName(name: string) {
    const url = `${AppSettings.API_URI_V2}/cities?search=${name}`;
    return this.common.getData(url);
  }

  postCiudades(payload: { name; state }) {
    const formHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    const url = `${AppSettings.API_URI_V2}/cities`;
    return this.http.post<any>(url, payload, formHeaders).pipe(
      map((data) => {
        if (data) {
          return data;
        } else return of(false);
      }),
      catchError((err) => {
        return of(false);
      }),
    );
  }

  putCiudades(id: number, payload: { name; state }) {
    const formHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    const url = `${AppSettings.API_URI_V2}/cities/${id}`;
    return this.http.put<any>(url, payload, formHeaders).pipe(
      map((data) => {
        return data;
      }),
      catchError((err) => {
        return of(false);
      }),
    );
  }

  deleteCiudad(id: number) {
    const url = `${AppSettings.API_URI_V2}/cities/${id}`;
    return this.http.delete<any>(url).pipe(
      map((data) => {
        return data;
      }),
      catchError((err) => {
        return of(false);
      }),
    );
  }

  createAndGetCity(payload: {
    city: string;
    province: string;
    country: string;
    country_code: string;
  }) {
    const formHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('jwt_token')}`,
      }),
    };

    const url = `${AppSettings.API_URI_V2}/cities/create-and-get`;
    return this.http.post<any>(url, payload, formHeaders).pipe(
      map((res) => res.data), // Extraemos { id_city: 21 }
      catchError((err) => throwError(() => err)),
    );
  }
}
